export default __webpack_public_path__ + "static/media/about.f0f6e1a4.png";